import * as z from 'zod';

import { ExternalListStatus } from './enums/external-list-status.enum';

export const ExternalListStatusSchema = z.object({
  description: z.string().optional(),
  id: z.nativeEnum(ExternalListStatus),
  name: z.string(),
});
export type IExternalListStatus = z.infer<typeof ExternalListStatusSchema>;
